import React from 'react';
import BlogDetailView from '../Components/BlogDetailView';

const BlogPostPreview = () => <BlogDetailView preview />;

export default BlogPostPreview;
